const Loading = () => (
  <div className="d-flex justify-content-center align-items-center">
    <img src="/loading.gif" alt="loading" style={{ width: '100%', objectFit: 'contain', height: '350px' }} />
  </div>
);

export default Loading;
